import React from "react";
import { Col, Table } from "react-bootstrap";
import ImageViewer from "../../components/ImageViewer";
import ViewExpenseApproveData from "./ViewExpenseApproveData";
import { formatAmountINR, to3 } from "../../utils/helper";

const ViewExpensePunch = ({ edit, viewType }) => {
   console.log(`edit`, edit);
  return (
   
    <>
      {viewType == "approveData" ? (
        <ViewExpenseApproveData edit={edit} />
      ) : (
        <>
        <Col md={6}>
  <div className="p-20 shadow rounded h-100">
    <strong className="text-secondary">Request By Details</strong>

    <div className="mt-2">
      <table className="table table-sm" style={{ tableLayout: "fixed" }}>
        <tbody>
          {/* User Name */}
          <tr>
            <th
              className="align-middle"
              style={{ width: "180px", whiteSpace: "nowrap" }}
            >
              User Name :
            </th>
            <td className="align-middle">
              <ImageViewer
                src={
                  edit?.user_image
                    ? `${process.env.REACT_APP_API_URL}${edit?.user_image}`
                    : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                }
              >
                <img
                  width={30}
                  height={30}
                  className="my-bg object-fit p-1 rounded-circle me-2"
                  src={
                    edit?.user_image
                      ? `${process.env.REACT_APP_API_URL}${edit?.user_image}`
                      : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                  }
                />
                {edit?.user_name}
                {edit?.employee_id
                  ? ` - ${edit?.employee_id}`
                  : null}
              </ImageViewer>
            </td>
          </tr>

          {/* Company Name */}
          {edit?.complaintDetails && (
            <tr>
              <th style={{ width: "180px", whiteSpace: "nowrap" }}>
                Company Name :
              </th>
              <td>
                {
                  edit?.complaintDetails?.companyDetails
                    ?.company_name
                }
              </td>
            </tr>
          )}

          {/* Regional Office */}
          {edit?.complaintDetails?.companyDetails
            ?.selectedRegionalOffices && (
            <tr>
              <th style={{ width: "180px", whiteSpace: "nowrap" }}>
                Regional Office :
              </th>
              <td className="text-dark">
                {edit?.complaintDetails?.companyDetails?.selectedRegionalOffices.map(
                  (ro, idx) => (
                    <span key={idx} className="me-2">
                      {ro.regional_office_name}
                    </span>
                  )
                )}
              </td>
            </tr>
          )}

          {/* Sales Area */}
          {edit?.complaintDetails?.companyDetails
            ?.selectedSaleAreas && (
            <tr>
              <th style={{ width: "180px", whiteSpace: "nowrap" }}>
                Sales Area :
              </th>
              <td className="text-dark">
                {edit?.complaintDetails?.companyDetails?.selectedSaleAreas.map(
                  (sale, idx) => (
                    <span key={idx} className="me-2">
                      {sale.sales_area_name}
                    </span>
                  )
                )}
              </td>
            </tr>
          )}

          {/* District */}
          {edit?.complaintDetails?.companyDetails
            ?.selectedDistricts && (
            <tr>
              <th style={{ width: "180px", whiteSpace: "nowrap" }}>
                District :
              </th>
              <td className="text-dark">
                {edit?.complaintDetails?.companyDetails?.selectedDistricts.map(
                  (dict, idx) => (
                    <span key={idx} className="me-2">
                      {dict.district_name}
                    </span>
                  )
                )}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
</Col>


          <Col md={6}>
            <div className="p-20 shadow rounded h-100">
              <strong className="text-secondary">Complaint Details</strong>
              <div className="mt-2">
                <table className="table-sm table">
                  <tbody>
                    {edit?.complaintDetails?.complaint_unique_id && (
                      <tr>
                        <th>Complaint Id :</th>
                        <td>
                          {edit?.complaintDetails?.complaint_unique_id}
                        </td>
                      </tr>
                    )}
                    {edit?.complaintDetails && (
                      <tr>
                        <th>Complaint Raise By :</th>
                        <td>
                          {
                            edit?.complaintDetails?.complaintRaiserDetails
                              ?.name
                          }
                        </td>
                      </tr>
                    )}
                    {edit?.complaintDetails?.complaint_type && (
                      <tr>
                        <th>Complaint Type :</th>
                        <td>{edit?.complaintDetails?.complaint_type}</td>
                      </tr>
                    )}

                    {edit?.complaintDetails?.manager_and_supevisor
                      ?.areaManagerDetails?.id && (
                      <tr>
                        <th className="align-middle">Manager :</th>
                        <td>
                          <ImageViewer
                            src={
                              edit?.complaintDetails?.manager_and_supevisor
                                ?.areaManagerDetails?.image
                                ? `${process.env.REACT_APP_API_URL}${edit?.complaintDetails?.manager_and_supevisor?.areaManagerDetails?.image}`
                                : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                            }
                          >
                            <img
                              width={35}
                              height={35}
                              className="my-bg object-fit p-1 rounded-circle"
                              src={
                                edit?.complaintDetails
                                  ?.manager_and_supevisor?.areaManagerDetails
                                  ?.image
                                  ? `${process.env.REACT_APP_API_URL}${edit?.complaintDetails?.manager_and_supevisor?.areaManagerDetails?.image}`
                                  : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                              }
                            />{" "}
                          </ImageViewer>
                          {
                            edit?.complaintDetails?.manager_and_supevisor
                              ?.areaManagerDetails?.name
                          }{" "}
                          -{" "}
                          {
                            edit?.complaintDetails?.manager_and_supevisor
                              ?.areaManagerDetails?.employee_id
                          }
                        </td>
                      </tr>
                    )}
                    {edit?.complaintDetails?.manager_and_supevisor
                      ?.superVisorDetails?.id && (
                      <tr>
                        <th className="align-middle">SuperVisor :</th>
                        <td>
                          <ImageViewer
                            src={
                              edit?.complaintDetails?.manager_and_supevisor
                                ?.superVisorDetails?.image
                                ? `${process.env.REACT_APP_API_URL}${edit?.complaintDetails?.manager_and_supevisor?.superVisorDetails?.image}`
                                : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                            }
                          >
                            <img
                              width={35}
                              height={35}
                              className="my-bg object-fit p-1 rounded-circle"
                              src={
                                edit?.complaintDetails
                                  ?.manager_and_supevisor?.superVisorDetails
                                  ?.image
                                  ? `${process.env.REACT_APP_API_URL}${edit?.complaintDetails?.manager_and_supevisor?.superVisorDetails?.image}`
                                  : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                              }
                            />{" "}
                          </ImageViewer>
                          {
                            edit?.complaintDetails?.manager_and_supevisor
                              ?.superVisorDetails?.name
                          }{" "}
                          -{" "}
                          {
                            edit?.complaintDetails?.manager_and_supevisor
                              ?.superVisorDetails?.employee_id
                          }
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </Col>

          <Col md={12}>
            <div className="p-20 shadow rounded h-100">
              <strong className="text-secondary">Expense Punch Detail</strong>
              <div className="mt-2">
                <Table className="table-sm table Roles">
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th style={{ minWidth: "250px", padding: "0px" }}>Item</th>
                      <th style={{ minWidth: "100px", padding: "0px" }}>HSN Code</th>
                      <th style={{ minWidth: "100px", padding: "0px" }}>Brand</th>
                      <th style={{ minWidth: "80px", padding: "0px" }}> Item Price</th>
                      <th style={{ minWidth: "80px", padding: "0px" }}> Punch Qty</th>
                      <th style={{ minWidth: "80px", padding: "0px" }} >Punch Amount</th>
                      <th style={{ minWidth: "150px", padding: "0px" }}>Punch Date & Time</th>
                      <th style={{ minWidth: "80px", padding: "0px" }}>Remaining Quanity</th>
                  <th style={{ minWidth: "80px", padding: "0px" }}>Remaining Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {edit?.items?.length > 0 &&
                      edit.items.map((itm, idx) => (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td>
                            <ImageViewer
                              src={
                                itm?.item_images
                                  ? `${process.env.REACT_APP_API_URL}${itm?.item_images}`
                                  : `${process.env.REACT_APP_API_URL}/assets/images/no-image.png`
                              }
                            >
                              <img
                                width={30}
                                height={30}
                                className="my-bg object-fit p-1 rounded-circle"
                                src={
                                  itm?.item_images
                                    ? `${process.env.REACT_APP_API_URL}${itm.item_images}`
                                    : `${process.env.REACT_APP_API_URL}/assets/images/no-image.png`
                                }
                              />{" "}
                              {itm?.item_name}
                            </ImageViewer>
                          </td>
                          <td>{itm?.hsncode || "-"}</td>
                          <td>{itm?.brand_name || "-"}</td>
                          <td>{formatAmountINR(itm.item_price)}</td>
                          <td>{to3(itm.punched_qty)}</td>
                          <td>{formatAmountINR(itm.total_Amount)}</td>
                          <td>{edit?.punch_at}</td>
                          <td>{to3(itm.item_remaining_qty)}</td>
                          <td>{formatAmountINR(itm.item_remaining_amt)}</td>

                        </tr>
                      ))}
                  </tbody>
                </Table>
              </div>
            </div>
          </Col>
        </>
      )}
    </>
  );
};

export default ViewExpensePunch;
